import { withInstall } from '@zoryn/utils'
import GridImport from './src/grid-import.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZGridImport: SFCWithInstall<typeof GridImport> = withInstall(GridImport)
export default ZGridImport

export * from './src/grid-import'
export * from './src/types'
export * from './src/import'
export type { GridImportInstance } from './src/instance'
